export default "__VITE_ASSET__BJ1uVrVn__"